<template>
  <div>
    <div>
    </div>
    <div>
      <a
        style="font-size: 1.3em;"
        :href="
          'https://secure.medicalalley.org/admin/accounts/' +
            organization.account_id
        "
        target="_blank"
      >
        {{ organization.name }}
      </a>
    </div>
    <div class="d-flex">
      Issues:
      <span
        class="badge badge-maadi m-1"
        v-for="violation in violationArray.filter(x => x.validity !== 1)"
        :key="violation.label"
      >
        {{ violation.label }}
      </span>
    </div>
    <div v-if="!organization.logo_url"
        class="text-left"
        style="font-size: 10px; cursor: pointer"
        @click="toggled.logoUploader = !toggled.logoUploader"
      >
        UPLOAD LOGO
      </div>
      <transition name="fade">
          <div class="d-flex flex-column" v-if="toggled.logoUploader" style="font-weight: 300; border: 1px solid #3E597A">
          <!-- logo upload -->
          <div >
            <div class="d-flex flex-column flex-fill p-2 m-1">
              <b-form class="d-flex flex-fill" v-if="!this.loading.imageUpload" @submit="uploadFile">
                <div class="d-flex flex-fill align-items-center">
                  <b-form-file
                    v-model="logoFile"
                    :state="Boolean(logoFile)"
                    placeholder="Upload member logo"
                    drop-placeholder="Drop file here..."
                    class="d-flex flex-fill"
                    size="sm"
                  ></b-form-file>
                </div>
                <div class="d-flex align-items-center ml-2">
                  <b-button size="sm" id="submit" type="submit">Submit</b-button>
                </div>
              </b-form>
            </div>
          </div>
          <div class="d-flex text-center justify-content-center" v-if="message !==null">
            {{ this.message }}
          </div>
        </div>
        </transition>
  </div>
</template>

<script>
import API from '../../../api/organizations'

export default {
  name: "",
  props: ["organization"],
  computed: {
    violationArray() {
      return [
        {
          label: "Primary Contact",
          validity: this.organization.has_primary_contact
        },
        {
          label: "Member Manager",
          validity: this.organization.has_member_manager
        },
        {
          label: "Category",
          validity: this.organization.has_category
        },
        {
          label: "QuickBooks",
          validity: this.organization.is_connected_to_intuit
        },
        {
          label: "WordPress",
          validity: this.organization.is_connected_to_wordpress
        },
        {
          label: "Logo",
          validity: this.organization.is_logo_valid
        },
        {
          label: "Website",
          validity: this.organization.is_website_valid
        },
        {
          label: "LinkedIn",
          validity: this.organization.is_linkedin_valid
        },
        {
          label: "Twitter",
          validity: this.organization.is_twitter_valid
        }
      ];
    }
  },
  data: function () {
    return {
      loading: {
        imageUpload: false,
      },
      messages: {
        imageUpload: null
      },
      toggled: {
        logoUploader: false
      },
      logoToggled: false,
      logoFile: null,
      message: null
    }
  },
  methods: {
    uploadFile (e) {
      e.preventDefault()
      this.loading.imageUpload = true
      let formData = new FormData()
      formData.append('file', this.logoFile)
      API.uploadOrganizationLogo(this.organization.account_id, formData).then(
        result => {
          this.loading.imageUpload = false
          this.logoFile = null
          if (result.data.success) {
            this.message = 'Success!'
          } else {
            this.message = result.message
          }
        }
      )
    },
  }
};
</script>

<style scoped>
.badge-maadi {
  background: #c1272d;
}
</style>



// WEBPACK FOOTER //
// src/components/membership/dataValidity/SingleMemberValidityRecord.vue